import { useCallback, useState } from "react";

export default function useInput2(init = '', dropOnChange = true) {
	const [value, setValue] = useState(init);
	const [error, setError] = useState(null);
	const onChange = useCallback(ev => {
		if (dropOnChange) setError(null);
		setValue(ev.target.value);
	}, [dropOnChange]);
	const setVal = useCallback(v => {
		if (dropOnChange) setError(null);
		setValue(v);
	}, [dropOnChange]);
	// return [value, pset, pon, error, setError];
	return [value, setVal, onChange, error, setError];
}